import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { fullWarrantyMonths, warrantyHasExtraDays } from '../model/warrantyDates';

interface WarrantyTermMonthsProps {
    id: string;
    purchasedAt: string;
    warrantyUntil: string;
    disabled?: boolean;
    onChangeMonths: (months: number) => void;
}

const WarrantyTermMonths = ({
    id,
    purchasedAt,
    warrantyUntil,
    disabled = false,
    onChangeMonths,
}: WarrantyTermMonthsProps) => {
    const { t } = useTranslation('Warranties');
    const [focused, setFocused] = useState(false);
    const [draft, setDraft] = useState('');
    const derivedMonths = fullWarrantyMonths(purchasedAt, warrantyUntil);
    const monthsValue = focused ? draft : (derivedMonths == null ? '' : String(derivedMonths));
    const extra = !focused && warrantyHasExtraDays(purchasedAt, warrantyUntil);

    return (
        <div
            className="warranty-term-months"
            title={extra ? t('fields.termMonthsExtra') : undefined}
        >
            <Form.Control
                id={id}
                type="number"
                min={1}
                step={1}
                inputMode="numeric"
                disabled={disabled}
                value={monthsValue}
                className={extra ? 'warranty-term-months__input' : undefined}
                onFocus={() => {
                    setDraft(derivedMonths == null ? '' : String(derivedMonths));
                    setFocused(true);
                }}
                onBlur={() => setFocused(false)}
                onChange={(event) => {
                    const raw = event.target.value.trim();
                    if (raw !== '' && !/^\d+$/.test(raw)) return;
                    setDraft(raw);
                    const months = Number(raw);
                    if (!Number.isInteger(months) || months < 1) return;
                    onChangeMonths(months);
                }}
            />
            {extra ? (
                <span className="warranty-term-months__extra text-muted fw-medium" aria-hidden="true">
                    +
                </span>
            ) : null}
            {warrantyHasExtraDays(purchasedAt, warrantyUntil) ? (
                <span className="visually-hidden">{t('fields.termMonthsExtra')}</span>
            ) : null}
        </div>
    );
};

export default WarrantyTermMonths;
